var _defs, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMetroFileEmpty = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71.113,
    height: 82.139,
    viewBox: "0 0 71.113 82.139",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".metro{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "metro",
    d: "M55.294,1.928H4.5V84.067H75.612V24.455C75.612,23.305,56.431,1.928,55.294,1.928ZM67.513,22.463H55.294V10.114A171.557,171.557,0,0,1,67.513,22.463Zm3.02,56.471c0,.7-60.954,0-60.954,0-.523-.105-.688-71.872,0-71.872H50.214V27.6H70.532Z",
    transform: "translate(-4.499 -1.928)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMetroFileEmpty, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/metro-file-empty.393629bf.svg";
export { ForwardRef as ReactComponent };